const defaultTheme = {
  layout: {
    maxWidth: "1200px",
    sectionInner: `
      width: 100%;
      max-width: 1200px;
      margin: 0 auto;
    `
  }, 
  global: {
    'html, body': {
      fontSize: '16px'
    },
  },
  fonts: {
    body: "NanumSquareRound, sans-serif",
    heading: "NanumSquareRound, sans-serif",
    mono: "Menlo, monospace",
  },
  fontSizes: {
    xs: "0.75rem", // 12
    sm: "0.875rem", // 14
    md: "1rem", // 16px
    lg: "1.125rem", // 18px 
    xl: "1.25rem", // 20px
    "2xl": "1.5rem", // 24px
    "3xl": "1.875rem", // 30px
    "4xl": "2.125rem", // 34px
    "5xl": "3rem", // 48px
    "6xl": "3.75rem", // 60px
    "7xl": "4.5rem", // 64px
    "8xl": "6rem", // 72px
    "9xl": "8rem", // 96px
  },
  colors: {
    b: {
      gr: '#83B582',
      dgr: '#6C8255',
      g: '#727171',
      lg: '#B5B5B6',
      llg: '#f9f9f9',
      wh: '#FFFFFF',
      og: '#F6AF70',
      yl: '#FEDF8F',
      bk: '#000000',
    },
    dgr: {
      50: '#e9f8e9',
      100: '#cce4cd',
      200: '#afd0ae',
      300: '#90bd8f',
      400: '#71aa70',
      500: '#579056',
      600: '#437042',
      700: '#2f502e',
      800: '#1b311a',
      900: '#031201',
    },
    g: {
      50: '#feeef2',
      100: '#dfd7d9',
      200: '#c3bebe',
      300: '#a7a5a5',
      400: '#8d8c8c',
      500: '#737272',
      600: '#5b5959',
      700: '#423e3e',
      800: '#2a2526',
      900: '#17090d',
    },
    og: {
      50: '#fff1df',
      100: '#fcd7b4',
      200: '#f7bc87',
      300: '#f3a158',
      400: '#f0872a',
      500: '#F6AF70',
      600: '#f3a158',
      700: '#f0872a',
      800: '#492302',
      900: '#1d0a00',
    },
    wh: {
      50: '#ffffff',
      100: '#ffffff',
      200: '#ffffff',
      300: '#ffffff',
      400: '#ffffff',
      500: '#ffffff',
      600: '#ffffff',
      700: '#ffffff',
      800: '#ffffff',
      900: '#ffffff',
    }
  },
  breakpoints: {
    sm: "640px",
    md: "860px",
    lg: "1200px",
    xl: "1400px",
  },
  components: {
    Heading: {
      baseStyle: {
        fontWeight: "800",
        lineHeight: "1.4",
      },
      sizes: {
        xs: { fontSize: "0.75rem", lineHeight: 1.2}, // 12
        sm: { fontSize: "0.875rem", lineHeight: 1.2}, // 14
        md: { fontSize: "1rem", lineHeight: 1.2}, // 16px
        lg: { fontSize: "1.125rem", lineHeight: 1.2}, // 18px 
        xl: { fontSize: "1.25rem", lineHeight: 1.2}, // 20px
        "2xl": { fontSize: "1.5rem", lineHeight: 1.2}, // 24px
        "3xl": { fontSize: "1.875rem", lineHeight: 1.2}, // 30px
        "4xl": { fontSize: "2.125rem", lineHeight: 1.2}, // 34px
        "5xl": { fontSize: "3rem", lineHeight: 1.2}, // 48px
        "6xl": { fontSize: "3.75rem", lineHeight: 1.2}, // 60px
        "7xl": { fontSize: "4.5rem", lineHeight: 1.2}, // 64px
        "8xl": { fontSize: "6rem", lineHeight: 1.2}, // 72px
      },
    },
    Button: {
      // 1. We can update the base styles
      baseStyle: {
        fontWeight: 'bold', // Normally, it is "semibold"
        borderRadius: '500px'
      },
      // 2. We can add a new button size or extend existing
      sizes: {
        md: {
          h: '36px',
          fontSize: 'md',
          paddingLeft: '8',
          paddingRight: '8'
          // px: '32px',
        },
        lg: {
          h: '48px',
          fontSize: '2xl',
          paddingLeft: '6',
          paddingRight: '6'
          // px: '32px',
        },
        xl: {
          h: '60px',
          fontSize: 'xl',
          paddingLeft: '8',
          paddingRight: '8'
          // px: '32px',
        },
      },
    },
    Text: {
      baseStyle: {
        lineHeight: '1.5',
      }
    },
    Input: {
      baseStyle: {
        field: {
          bg: 'wh',
          backgroundColor: 'b.wh',
          borderRadius: '8px',
          borderColor: 'b.dgr'
        }
      },
      defaultProps: {
        // bg: 'wh',
      }
    }
  }
}

export const responsiveValue:any = {
  flexBoxDirection: { base: "column", md: "row", lg: "row" },
  participationSideBoxWidth: { base: "100%", md: "26%", lg: "26%" },
  participationContentBoxWidth: { base: "100%", md: "74%", lg: "74%" },
  participationContentTextLineHeight: { base: "1.6", md: "1", lg: "1" },
  lineBreakOnMobile: {display: { base: "inline", md: 'none', lg: "none" }},
}

export default defaultTheme;
